import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { useBuilder } from '../../store/provider';
import { useNormsSuggestions } from '../../store/suggestions';
import type { Suggestion } from '../../store/types';
import PatchCard from './primitives/patch-card';
import ProseDiff from './primitives/prose-diff';
const NormsSuggestions = () => {
  const $ = _c(4);
  const suggestions = useNormsSuggestions();
  if (suggestions.length === 0) {
    return null;
  }
  let t0;
  if ($[0] !== suggestions) {
    t0 = suggestions.map(_temp);
    $[0] = suggestions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="flex flex-col gap-3">{t0}</div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
type Props = {
  suggestion: Suggestion;
};
const NormsPatchCard = t0 => {
  const $ = _c(14);
  const {
    suggestion
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.suggestion.norms"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const {
    state
  } = useBuilder();
  const op = suggestion.operation;
  if (op.kind !== "update_norms") {
    return null;
  }
  const t2 = suggestion.id;
  let t3;
  if ($[1] !== t) {
    t3 = t(_temp2);
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = !suggestion.canApply;
  let t5;
  if ($[3] !== t) {
    t5 = t(_temp3);
    $[3] = t;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== op.norms || $[6] !== state.bundle.norms) {
    t6 = <ProseDiff current={state.bundle.norms} suggested={op.norms} />;
    $[5] = op.norms;
    $[6] = state.bundle.norms;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== suggestion.id || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <PatchCard suggestionId={t2} note={t3} isStale={t4} title={t5} showDiffToggle={true}>{t6}</PatchCard>;
    $[8] = suggestion.id;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default NormsSuggestions;
function _temp(s) {
  return <NormsPatchCard key={s.id} suggestion={s} />;
}
function _temp2($) {
  return $.refined;
}
function _temp3($_0) {
  return $_0.title;
}